<template>
  <div>
    <OurSolutionPopup
      :isActive="isDetailsActive"
      :selectedService="selectedService"
      @close="toggleDetails"
    />
    <div class="relative z-index1">
      <img
        src="@/assets/images/line/Frame 1000002302.png"
        alt="lineimg"
        class="m-auto"
      />
      <div class="absolute bg-design-col-t z-index--1 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-col-d absolute z-index--1 mob-hidden">
        <img
          src="../../../assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-col-ecli absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="w-full mx-auto md:px-0 lg:px-0 px-4">
        <p class="title lg:font-normal md:font-normal font-bold sm-fsize16">
          Our Services:
        </p>

        <div
          class="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-2 md:gap-8 lg:gap-8 gap-4 pt-6"
        >
          <div
            class="md:p-10 lg:p-10 p-6 rounded-2xl cursor-pointer"
            v-for="(item, index) in points"
            :key="index"
            :style="{ 'background-color': item.color }"
            @click="toggleDetails(true, item)"
          >
            <div class="w-full cust-bg">
              <p class="mc-title fsize20-16">{{ item.name }}</p>
              <p class="pt-4 mc-subtitle ellipsis-3 fsize18-14 cursor-pointer">
                {{ item.subtitle }}
              </p>
            </div>
          </div>
          <!-- <div class="bgEEE2FF  p-8 rounded-2xl">
            <p class="mc-title">Culture Building / Policy Development</p>
            <p class="pt-4 mc-subtitle ellipsis-3">
              Caregiver Saathi's culture-building program will assist you in
              dealing with difficult situations! It is all about cultivating a
              work environment that allows employees to perform at their best.
              Programs/services: Companions for Caregivers: Bridging the
              professionals, EAPs Building a compassionate culture: Inclusion of
              caregivers, lean in/support circles Advisory on policies and best
              practices for caregivers & caregiving
            </p>
          </div>
          <div class="bgCCEFF2  p-8 rounded-2xl">
            <p class="mc-title">Community Building / CSR</p>
            <p class="pt-4 mc-subtitle ellipsis-3">
              The community building program is aimed at community leaders and
              workers of all types and in all situations around the world, as
              well as anybody who wants to strengthen their communities.
              Programs/services: Volunteering opportunities at Caregiver Saathi
              Training as Certified Caregiver Saathi for Respite Care CSR
              partnership for research, outreach programs to the marginalised &
              women in unpaid care-related work
            </p>
          </div>
          <div class="bgEEE2FF  p-8 rounded-2xl">
            <p class="mc-title">
              Conscious-life Building / Caregiver Services
            </p>
            <p class="pt-4 mc-subtitle ellipsis-3">
              Conscious building specifically for those bereaved, has its own
              uniqueness which allows us to process information according to our
              individual requirements and constantly changing interactions with
              the environment, allowing us to act independently.
              Programs/services:​ Emotional grief counselling, Financial & Legal
              support Creative expression and re-aligning life-work purpose
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OurSolutionPopup from "./OurSolutionPopup";
export default {
  components: {
    OurSolutionPopup,
  },
  data() {
    return {
      selectedService: {},
      isDetailsActive: false,
      points: [
        {
          id: "01",
          color: "#CCEFF2",
          name: "Advisory Services",
          html: `                <div class="">
<p class="mc-title-pp fsize20-16 pt-4">We will partner with you in running a diagnostic and implementing actions that will enable you to be a caregiver friendly and inclusive workplace.
 </p>
<p class="pt-4 mc-subtitle fsize18-14">Our Programs/services:  </p>
<ul class="pt-2 mc-subtitle fsize18-14 pl-4 list-disc">
  <li> Advisory on policies and best practices for caregivers & caregiving      </li>
  <li> Companions for Caregivers: Bridging the professionals, EAPs  </li>
  <li> Building a compassionate culture: Inclusion of caregivers, lean in/support circles
  </li>
</ul>
                </div>`,
          subtitle:
            "We will partner with you in running a diagnostic and implementing actions that will enable you to be a caregiver friendly and inclusive workplace.",
        },
        {
          id: "02",
          color: "#eee2ff",
          name: "Learning Interventions",
          html: `                <div>
<p class="mc-title fsize20-16 pt-4">We conduct training programs and workshops for leadership, managers, employees, and their families to enable them to make critical decisions in any form.</p>
<p class="pt-4 mc-subtitle fsize18-14">Our Programs/ services:
 </p>
<ul class="pt-2 mc-subtitle fsize18-14 pl-4 list-disc">
  <li>Learning tools and workshops on well-being, resilience, and  recovery
</li>
  <liIndividualised coaching to caregivers (balance work & caregiving role, preventing burnout)
</li>
  <li>Programs for leaders: Compassionate leadership, Managing grief at the workplace, and Inclusion of caregivers
</li>
</ul>
                </div>`,
          subtitle:
            "We conduct training programs and workshops for leadership, managers, employees and their families to enable them to make critical decisions in any form.",
        },
        {
          id: "03",
          color: "#eee2ff",
          name: "Employee Well-being ",
          html: `                <div class="">
<p class="mc-title fsize20-16 pt-4">
As a corporate partner, you will get access to curated caregiving services to support employees and their families.
</p>
<p class="pt-4 mc-subtitle fsize18-14">Our Programs/services:​
 </p>
<ul class="pt-2 mc-subtitle fsize18-14 pl-4 list-disc">
  <li>Home Care solutions and resources directory
</li>
  <li>Self-Care programmes like coaching, counselling, and therapy </li>
   <li>Medical support like e-pharmacy for specialised medicines and equipment </li>
    <li>Financial, legal, and inheritance related advisory and support services
 </li>

</ul>
                </div>`,
          subtitle:
            "As a corporate partner you will get access to curated caregiving services to support employees and their families.",
        },
        {
          id: "04",
          color: "#CCEFF2",
          name: "ESG/CSR Partnerships",
          html: `                <div class="">
<p class="mc-title fsize20-16 pt-4">An opportunity for business organisations to participate in building a sustainable community for caregivers and contribute to impacting the care economy in many ways.</p>
<p class="pt-4 mc-subtitle fsize18-14">Our Programs:</p>
<ul class="pt-2 mc-subtitle fsize18-14 pl-4 list-disc ">
  <li>Livelihoods and Training of women as Care Workers in Palliative Care and for specific medical conditions like Dementia, ALS</li>
  <li>Research, Advocacy, and Awareness of palliative care among communities through outreach programs for the marginalized </li>
    <li>Volunteering opportunities for employees at Caregiver Saathi- which range from supporting community visits for home-based care, conducting workshops, and providing organizational administrative support
</li>

</ul>
                </div>`,
          subtitle:
            "An opportunity for business organisations to participate in building a sustainable community for caregivers and contribute in impacting the care economy in many ways.",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedService = item;
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .smh-935px {
    height: 935px !important;
  }
}
</style>
